{
  "en": {
    "datatable": {
      "actions": {
        "bulk_action": "Bulk action",
        "bulk_edit": "Bulk edit",
        "clear_filters": "Clear filters",
        "collapse_all": "Collapse all",
        "deselect_all": "Deselect all",
        "expand_all": "Expand all",
        "select_all": "Select all"
      },
      "import": {
        "title": "Import",
        "success": "File imported successfully",
        "errors_title": "Import failed",
        "errors_description": "The import was cancelled because {count} row(s) contained errors. No records were imported.",
        "error_row": "Row {row}"
      },
      "labels": {
        "gridlines": "Grid lines",
        "size": "Size",
        "sticky_headers": "Sticky headers",
        "striped_rows": "Striped rows",
        "toggle_columns": "Toggle columns",
        "freeze_rows": "Freeze rows",
        "freeze_columns": "Freeze columns",
        "group_by": "Group by"
      }
    }
  }
}
